import { render } from "./ToolSelector.vue?vue&type=template&id=533e4327&scoped=true"
import script from "./ToolSelector.vue?vue&type=script&lang=js"
export * from "./ToolSelector.vue?vue&type=script&lang=js"

import "./ToolSelector.vue?vue&type=style&index=0&id=533e4327&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533e4327"]])

export default __exports__